module.exports = __webpack_public_path__ + "static/media/Raffrollo_35618_130x160.183b2025.png";